import { FormEvent, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import intl from "react-intl-universal";
import { FiArrowRight, FiMail } from "react-icons/fi";
import { MyFirstAccessContext } from "..";
import { FirstAccessShell } from "../FirstAccessShell";
import {
  getFirstAccessErrorMessage,
  isFirstAccessFailure,
} from "../types";
import {
  normalizeFirstAccessInput,
  prepareUsernameForApi,
  validateFirstAccessUsername,
} from "../utils";

/** Entry / invite context: identify person (no OTP yet). */
export const SendEmail = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { identifyUser } = useContext(MyFirstAccessContext);

  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    const validationError = validateFirstAccessUsername(username);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setIsLoading(true);

    const payload = prepareUsernameForApi(username);
    const result = await identifyUser(payload);

    setIsLoading(false);

    if (isFirstAccessFailure(result)) {
      enqueueSnackbar(
        getFirstAccessErrorMessage(result, intl.get("firstAccess.identifyError")),
        { variant: "error" }
      );
      return;
    }

    history.push("/auth/my-first-access/confirm-cpf");
  };

  return (
    <FirstAccessShell
      title={intl.get("firstAccess.title")}
      subtitle={intl.get("firstAccess.subtitleIdentify")}
    >
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-field-group">
          <label className="login-field-label" htmlFor="first-access-username">
            {intl.get("auth.documentOrEmail")}
          </label>
          <div className="login-field">
            <span className="login-field__icon">
              <FiMail />
            </span>
            <input
              id="first-access-username"
              name="username"
              type="text"
              autoComplete="username"
              placeholder={intl.get("auth.documentOrEmailPlaceholder")}
              value={username}
              onChange={(event) => {
                setError("");
                setUsername(normalizeFirstAccessInput(event.currentTarget.value));
              }}
              className="login-field__input"
            />
          </div>
          {error ? <p className="login-field__error">{error}</p> : null}
        </div>

        <button
          type="submit"
          className="login-submit-btn"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="login-submit-btn__spinner" />
              {intl.get("firstAccess.continuing")}
            </>
          ) : (
            <>
              {intl.get("firstAccess.continue")}
              <FiArrowRight />
            </>
          )}
        </button>
      </form>
    </FirstAccessShell>
  );
};
